import { environment } from '../environments/environment';

export const { baseApiUrl } = environment;

const baseAuthUrl = `${baseApiUrl}auth`;

export const getAuthUserUrl = () => {
  const baseUrl = baseAuthUrl.replace('/v1.0', '');
  return `${baseUrl}/getuser`;
};
